import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import ProductPageInstructorTable from "../../../components/AdminPanel/ProductPageInstructor/ProductPageInstructorTable/ProductPageInstructorTable";
import ProductPageInstructorHeader from "../../../components/AdminPanel/ProductPageInstructor/ProductPageInstructorHeader";

import BoxShadow from "../../../shared/BoxShadow/BoxShadow";

const ProductPageInstructor = () => {
  return (
    <AdminPanelLayout>
      <BoxShadow>
     <div className="mt-7">
     <ProductPageInstructorHeader />
        <ProductPageInstructorTable />
     </div>
      </BoxShadow>
      {/* <TeamsFooter /> */}
    </AdminPanelLayout>
  );
};

export default ProductPageInstructor;
